export * from './tour.page';
export * from './tour.page.resolver';
